import { ALERT_CONDITION_TYPES, METRIC_NAMES } from '@config/Consts';
import { i18nHandlers } from './i18n';

const milliHash = {
  seconds: 1000,
  minutes: 1000 * 60,
  hours: 1000 * 60 * 60,
};

const i18nHash = {
  hours: 'time_unit_hour_long',
  minutes: 'time_unit_minute_long',
  seconds: 'time_unit_second_long',
};

/**
 * @param amount
 * @param unit
 * @return {number}
 */
function evaluateTime(amount, unit) {
  return amount * milliHash[unit];
}

/**
 * @param metrics
 * @param metricId
 * @return {null}
 */
function findMetricValue(metrics, metricId) {
  return metrics.find(item => item.metric === metricId).score || null;
}

/**
 * @param metrics
 * @param metricId
 * @return {null}
 */
function getMetric(metrics, metricId) {
  return metrics.find(item => item.metric === metricId) || null;
}

/**
 * @param alertData
 * @param agentStatus
 * @return {T[]}
 */
function filterAlertsDataForStateDuration(alertData, agentStatus) {
  return alertData.values.durationItems.filter((item) => {
    if (item.status.value === 'AWAY') {
      return item.status.value === agentStatus.status && item.statusReason.value === agentStatus.reason;
    }
    return item.status.value === agentStatus.status;
  });
}

/**
 * @name checkAlertsConfigured
 * @description Checks if alerts configured
 * @param alertsData
 * @return {{csatScore: boolean, currentStatus: boolean, currentStatusDuration: boolean}}
 */
function checkAlertsConfigured(alertsData) {
  return {
    [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS]: alertsData[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS] && !!alertsData[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS].values.timeframeValues.length,
    [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION]: alertsData[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION] && !!alertsData[METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_WITH_REASON_DURATION].values.durationItems.length,
    // [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS]: currentStatus && !!currentStatus.values.timeframeValues.length,
    // [METRIC_NAMES.AGENT_VIEW_AGENT_STATUS_DURATION]: currentStatusDuration && !!currentStatusDuration.values.durationItems.length,
    // [METRIC_NAMES.AGENT_VIEW_CSAT]: !!csat,
    // [METRIC_NAMES.AGENT_VIEW_AGENT_LOAD]: !!agentLoad,
    // [METRIC_NAMES.AGENT_VIEW_TRANSFER_RATE]: !!transferRate,
  };
}

/**
 * @name getIsAlertActiveForStandardMetric
 * @description Checks if alert should be shown for standard metric (only below and above types)
 * @param alert
 * @param metricScore
 * @return {{isAlert: boolean, value}}
 */
function getIsAlertActiveForStandardMetric(alert, metricScore) {
  const { value, condition } = alert;
  if (condition === ALERT_CONDITION_TYPES.BELOW) {
    return {
      isAlert: value > metricScore,
      value,
    };
  }
  return {
    isAlert: value < metricScore,
    value,
  };
}

export const AgentAlertsUtils = {
  checkAlertsConfigured,
  filterAlertsDataForStateDuration,
  getMetric,
  findMetricValue,
  evaluateTime,
  i18nHash,
  i18nHandlers,
  getIsAlertActiveForStandardMetric,
};
